export const DefaultCultureCode = 'en-US';

